import React from 'react';

const OtomasiDaurUlangPlastik: React.FC = () => {
  return (
    <div className="text-justify py-4 space-y-4">
      <p>
        Penumpukan limbah botol plastik sekali pakai dan sampah kemasan sintetis telah menjadi salah satu krisis lingkungan paling pelik di berbagai kota dan daerah wisata. Meskipun bank sampah telah banyak didirikan, proses pemilahan jenis plastik dan pencacahan manual sering kali berjalan lambat, menguras tenaga fisik, serta rentan terhadap kesalahan kontaminasi jenis polimer yang menurunkan nilai jual bahan daur ulang.
      </p>

      <p>
        Melihat persoalan tersebut, para inovator muda dalam kompetisi Innovative Technology Challenge merancang prototipe mesin pemilah dan pencacah plastik otomatis skala mini (Smart Plastic Shredder). Perangkat kompak ini menggabungkan sensor jarak inframerah, motor servo berkekuatan tinggi, dan modul mikrokontroler untuk mendeteksi keberadaan botol, mengklasifikasikan jenis material, serta memasukkannya ke dalam bilah pencacah secara teratur dan aman.
      </p>

      <p>
        Keamanan operasional menjadi prioritas utama dalam rancang bangun mesin ini. Seluruh mata pisau pencacah dilindungi dalam bilik tertutup ganda dengan sensor penutup magnetik yang secara otomatis memutus arus listrik apabila pintu penutup terbuka saat mesin bekerja. Desain pengaman pintar ini memastikan bahwa perangkat dapat dioperasikan dengan aman oleh siswa di lingkungan sekolah maupun pengelola bank sampah komunitas.
      </p>

      <p>
        Serpihan cacahan plastik (plastic flakes) yang dihasilkan memiliki ukuran seragam yang siap dilebur kembali menjadi filament pencetak 3D (3D printing filament) atau produk kerajinan bernilai ekonomis tinggi. Dengan mendaur ulang sampah plastik secara mandiri di lokasi sumber sampah, volume pengangkutan menuju tempat pembuangan akhir dapat ditekan secara signifikan.
      </p>

      <p>
        Inovasi mesin otomasi daur ulang ini menegaskan peran strategis generasi muda dalam mendorong ekonomi sirkular. Memadukan keahlian mekanika terapan, otomasi elektronik, dan kepedulian lingkungan hidup melahirkan solusi teknologi yang berdampak langsung bagi kebersihan dan keberlanjutan bumi.
      </p>
    </div>
  );
};

export default OtomasiDaurUlangPlastik;
